import React from 'react';
import PropTypes from 'prop-types';

import { TooltipHelp } from '@weezevent/nacre';

export default function TooltipIcon({ content }) {
    return <TooltipHelp mini title={content} />;
}

TooltipIcon.propTypes = {
    content: PropTypes.node
};
